// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CustomPagination{display:flex;flex-wrap:wrap;justify-content:center;margin-top:30px}@media (min-width: 768px){.CustomPagination{justify-content:flex-start}}.CustomPagination-ListItem{padding:0;margin-right:10px;margin:10px 10px 0 0;cursor:pointer}\n", ""]);
// Exports
module.exports = exports;
